import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Unstable_Grid2';
import SignIn from '../../components/pages/Login/SignIn';
import ImageHero from '../../images/pana.png';
import { FullHeightOnly } from '../../components/shared/Grid';
import TemplateDefault from '../../layout/TemplateDefault';
import { useIsLoggedIn } from '../../shared/hooks';
import { RootState } from '../../store';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate();
  const isLoggedIn = useIsLoggedIn();
  const {
    oyana: { me },
    redirect: { redirectTo }
  } = useSelector((state: RootState) => state);

  useEffect(() => {
    if (isLoggedIn && !me.id) {
      if (redirectTo && redirectTo.length > 0) {
        navigate(redirectTo);
      } else {
        navigate('/');
      }
    }
  }, [isLoggedIn, me.id]);

  return (
    <TemplateDefault>
      <FullHeightOnly container>
        <Grid xs={1} order={1} sx={{ display: { xs: 'none', md: 'block' } }}></Grid>
        <Grid xs={12} md={4} order={{ xs: 2, md: 4 }} sx={{ display: 'flex', alignItems: { xs: 'center', md: 'initial' } }}>
          <Box sx={{ mb: 5 }}>
            <CardMedia component="img" alt="computador" image={ImageHero} sx={{ width: { xs: 200, md: '100%' } }} />
          </Box>
        </Grid>

        <Grid xs={1} order={3} sx={{ display: { xs: 'none', md: 'block' } }}></Grid>
        <Grid xs={12} md={4} order={{ xs: 4, md: 2 }}>
          <Typography variant="h2" sx={{ mb: 4 }}>
            Acesse a sua conta
          </Typography>
          <SignIn />
        </Grid>
        <Grid xs={2} order={5} sx={{ display: { xs: 'none', md: 'block' } }}></Grid>
      </FullHeightOnly>
    </TemplateDefault>
  );
};

export default Login;
